"use client";

import Link from "next/link";
import { ExternalLink } from "lucide-react";
import { Button } from "../ui/button";
import { useCountry } from "@/hooks/use-country";

type ChipLinksProps = {
  data?: { title: string; slug: string }[];
};
export const ChipLinks = ({ data }: ChipLinksProps) => {
  const country = useCountry();
  return (
    <div className="space-x-1">
      {data?.map((item) => (
        <Button
          nativeButton={false}
          key={item.slug}
          variant="ghost"
          render={
            <Link href={country ? `/${country}/course/${item.slug}` : `/course/${item.slug}`} />
          }
        >
          {item.title} <ExternalLink />
        </Button>
      ))}
    </div>
  );
};
